import _ from 'lodash'
import {InitialsAvatar} from './initials_avatar'
import {ImageAvatar} from './image_avatar'

const makeAbbr = ({full_name, name, naam}) => {
	const _naam = full_name || name || naam
	if (!_naam || typeof _naam !== 'string') return
	const nom = _naam.split(' ').slice(0, 2)
	if (nom.length > 1) {
		return nom
			.filter(i => i)
			.map(v => v[0].toUpperCase())
			.join('')
	} else {
		return _naam.slice(0, 2).toUpperCase()
	}
}

export const UserAvatar = ({user, ...rest}) => {
	if (!user) return null
	const noAvatar = !_.isString(user?.avatar)
	const initials = makeAbbr(user)

	const fallback = <InitialsAvatar {...rest} initials={initials} />

	if (noAvatar) return fallback

	return <ImageAvatar {...rest} imageSrc={user.avatar} fallback={fallback} />
}
